import React from 'react';
import Modal from '../../../../../components/Modal';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import Anchor from '../../../../../components/link/Anchor';
import { PRODUCT_DISCOUNT_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../../constants/service/common/staticFileUrlConstants';
import './ExcelBulkEditProductDiscountModal.scss';

const ExcelBulkEditProductDiscountModal = (props) => {
  const { isOpen, file, onSubmit, onChange, closeModal } = props;

  return (
    <Modal
      title="상품 할인 일괄변경"
      isOpen={isOpen}
      width={600}
      height={220}
      isFooter={true}
      okText="상품 할인 일괄변경 처리"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="excel-bulk-edit-product-discount-modal-wrap">
        <div className="excel-bulk-edit-product-discount-title">
          <span className="guide">* 엑셀 파일을 업로드해주세요.</span>
          <Anchor
            className="template-download"
            text="일괄 할인 변경 양식 다운"
            isUnderLine={true}
            color="primary"
            href={PRODUCT_DISCOUNT_UPLOAD_TEMPLATE_XLSX_URL}
            target="_blank"
          />
        </div>

        <div className="excel-file-finder-section">
          <span className="file-name">{file ? file.name : ''}</span>
          <ExcelUploadForm onChange={(file) => onChange(file)} validExtension={['.xlsx']} />
        </div>

        <div className="excel-bulk-edit-product-discount-info">
          <div>- 우측 상단의 샘플 다운로드를 클릭한 후, 파일을 저장 해주세요.</div>
          <div className="emphasize">- 업로드하실 때는, 1행을 제외한 모든 행을 삭제하고 등록을 시작 해주세요.</div>
        </div>
      </div>
    </Modal>
  );
};

export default ExcelBulkEditProductDiscountModal;
